function uniqid() {
  var pr = '', en = false, result; function seed (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + seed(parseInt(new Date().getTime() / 1000, 10), 8) + seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();}
  return result;
}

function validatePhone(event) {
  const val = event.target.value;
  let content = [];
  Array.from(val).map(letter=>{
    if(!isNaN(letter)) {
        content.push(letter);
    }
  });
  let string = content.join("");
  event.target.value = string;
}

function validateDecimalNumber(event) {
  const val = event.target.value;
  let content = [];
  Array.from(val).map(letter=>{
    let validNumber = new RegExp(/^\d*\.?\d*$/);
    if(validNumber.test(letter)) {
        content.push(letter);
    }
  });
  let string = content.join("");
  event.target.value = string;
}

function number_format(str) {
    if (str == null) str = 0;
    return parseFloat(str)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

const getDepartamento = (view) => {
  switch (view) {
    case 'home':
      return 'Atención a clientes'
      break;
    case 'homeCaja':
      return 'Caja'
      break;
    case 'homeFinanzas':
      return 'Finanzas'
      break;
    case 'homeProcesos':
      return 'Procesos'
      break;
    default:
      return 'Administrador'
      break;
  }
}

export {
    validatePhone,
    number_format,
    validateDecimalNumber,
    uniqid,
    getDepartamento,
}